import React from 'react';

export const DashboardMainSummaryCards = ({ summary, formatNumber }) => {
    return (
        <div className="row g-3 mb-3">
            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-primary h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Clientes</div>
                        <span className="badge bg-white text-primary">CLI</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.customers)}</div>
                    <div className="text-muted fs-11 mt-1">Activos en plataforma</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-info h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Proyectos</div>
                        <span className="badge bg-white text-info">PRJ</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.projects)}</div>
                    <div className="text-muted fs-11 mt-1">Portafolio vigente</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-secondary h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Grupos</div>
                        <span className="badge bg-white text-secondary">GRP</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.groups)}</div>
                    <div className="text-muted fs-11 mt-1">Equipos configurados</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-warning h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Tickets</div>
                        <span className="badge bg-white text-warning">TKT</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.tickets)}</div>
                    <div className="text-muted fs-11 mt-1">En el período seleccionado</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-danger h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Abiertos</div>
                        <span className="badge bg-white text-danger">OPN</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.openTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Pendientes por atender</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-success h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fs-12 text-muted text-uppercase">Cerrados</div>
                        <span className="badge bg-white text-success">CLS</span>
                    </div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.closedTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Resueltos en período</div>
                </div>
            </div>
        </div>
    );
};
